import { useEffect, useRef, useState } from "react";
import { Cookies } from 'react-cookie';
import { toast, ToastContainer } from 'react-toastify';
import * as XLSX from 'xlsx';
import * as xlsx from 'xlsx';
import { useNavigate } from '../../../../node_modules/react-router-dom/dist/index';
import Footer from "../../Layout/FooterComponent";
import Loader from '../../Layout/Loader';

const cookies = new Cookies();

const UploadMasterForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorList, setErrorList] = useState([])

    const [SucessList, setSuccessList] = useState([])

    const [Records, setRecords] = useState(null)
    const navigate = useNavigate
    const [errorCount, setErrorCount] = useState([])
    const [SessionClear, SetSessionClear] = useState(false);
    const [successCount, setSuccessCounts] = useState([])
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [ExcelData, setExcelData] = useState([])
    const [EventCodeAutoComplete, setEventCodeAutoComplete] = useState([]);

    let error = (errorCount.pop() + 1)
    let success = (successCount.pop() + 1)

    const [formData, setFormData] = useState({
        EventCode: '',
    });
    const inputRefs = useRef([]);

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';
    let Count = 0;
    let Count1 = 0;

    const readFile = async (e) => {
        const file = e.target.files[0]
        const data = await file.arrayBuffer(file)
        const excelFile = xlsx.read(data)
        const excelSheet = excelFile.Sheets[excelFile.SheetNames[0]]
        const exceljson = xlsx.utils.sheet_to_json(excelSheet)
        setRecords(exceljson)
    }

    const handleSubmit = async () => {
        setIsLoading(true)
        let error = true;

        let errorList = []
        let SucessList = []

        let errorCounts = [];
        let successCounts = [];
        let TotalCounts = [];
        let response = {
            ...formData, Token, LoginUserCode, Source
        }
        if (response.EventCode === "") {
            toast.error('Please select Event.!', {})
            inputRefs.current["ddlEventCode"].focus()
            setIsLoading(false)
        }
        else {
            if (Records) {
                if (Object.keys(Records[0]).includes('VEHICLEID', 'VEHICLENUMBER', 'DRIVERMOBILE', 'CSC_REPRESETATIVE', 'CSC_REPMOBILE', 'DISTRICT_CODE', 'DISTRICT', 'DM_EMAIL', 'CUSTODIAN_CODE', 'CUSTODIAN_NAME', 'CUSTODIAN_MOBILE', 'CUSTODIAN_EMAILID', 'VENUE_CODE', 'VENUE_NAME', 'VENUE_CONTACT_PERSON', 'VENUE_MOBILE', 'VENUE_EMAIL', 'TRUNK_ID')) {

                    //if (response.status === "SUCESS") {

                    //}

                    for (let i = 0; i < Records.length; i++) {
                        await fetch('/api/ImportController/ImportTrunkData', {
                            method: 'POST',
                            body: JSON.stringify({
                                ...response,
                                VEHICLEID: Records[i]?.VEHICLEID ? (Records[i].VEHICLEID).toString() : '',
                                VEHICLENUMBER: Records[i]?.VEHICLENUMBER ? (Records[i]?.VEHICLENUMBER).toString() : "",
                                DRIVERMOBILE: Records[i]?.DRIVERMOBILE ? (Records[i]?.DRIVERMOBILE).toString() : "",
                                CSC_REPRESETATIVE: Records[i]?.CSC_REPRESETATIVE ? (Records[i]?.CSC_REPRESETATIVE).toString() : "",
                                CSC_REPMOBILE: Records[i]?.CSC_REPMOBILE ? (Records[i]?.CSC_REPMOBILE).toString() : "",
                                DISTRICT_CODE: Records[i]?.DISTRICT_CODE ? (Records[i]?.DISTRICT_CODE).toString() : "",
                                DISTRICT: Records[i]?.DISTRICT ? (Records[i]?.DISTRICT).toString() : "",
                                DM_EMAIL: Records[i]?.DM_EMAIL ? (Records[i]?.DM_EMAIL).toString() : "",
                                CUSTODIAN_CODE: Records[i]?.CUSTODIAN_CODE ? (Records[i]?.CUSTODIAN_CODE).toString() : "",
                                CUSTODIAN_NAME: Records[i]?.CUSTODIAN_NAME ? (Records[i]?.CUSTODIAN_NAME).toString() : "",
                                CUSTODIAN_MOBILE: Records[i]?.CUSTODIAN_MOBILE ? (Records[i]?.CUSTODIAN_MOBILE).toString() : "",
                                CUSTODIAN_EMAILID: Records[i]?.CUSTODIAN_EMAILID ? (Records[i]?.CUSTODIAN_EMAILID).toString() : "",
                                VENUE_CODE: Records[i]?.VENUE_CODE ? (Records[i]?.VENUE_CODE).toString() : "",
                                VENUE_NAME: Records[i]?.VENUE_NAME ? (Records[i]?.VENUE_NAME).toString() : "",
                                VENUE_CONTACT_PERSON: Records[i]?.VENUE_CONTACT_PERSON ? (Records[i]?.VENUE_CONTACT_PERSON).toString() : "",
                                VENUE_MOBILE: Records[i]?.VENUE_MOBILE ? (Records[i]?.VENUE_MOBILE).toString() : "",
                                VENUE_EMAIL: Records[i]?.VENUE_EMAIL ? (Records[i]?.VENUE_EMAIL).toString() : "",
                                TRUNK_ID: Records[i]?.TRUNK_ID ? (Records[i]?.TRUNK_ID).toString() : ""
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(async (response) => {
                            let res = await response.json();
                            if (res.status === "ERROR") {
                                errorList.push({
                                    VEHICLEID: Records[i]?.VEHICLEID ? (Records[i].VEHICLEID).toString() : '',
                                    VEHICLENUMBER: Records[i]?.VEHICLENUMBER ? (Records[i]?.VEHICLENUMBER).toString() : "",
                                    DRIVERMOBILE: Records[i]?.DRIVERMOBILE ? (Records[i]?.DRIVERMOBILE).toString() : "",
                                    CSC_REPRESETATIVE: Records[i]?.CSC_REPRESETATIVE ? (Records[i]?.CSC_REPRESETATIVE).toString() : "",
                                    CSC_REPMOBILE: Records[i]?.CSC_REPMOBILE ? (Records[i]?.CSC_REPMOBILE).toString() : "",
                                    DISTRICT_CODE: Records[i]?.DISTRICT_CODE ? (Records[i]?.DISTRICT_CODE).toString() : "",
                                    DISTRICT: Records[i]?.DISTRICT ? (Records[i]?.DISTRICT).toString() : "",
                                    DM_EMAIL: Records[i]?.DM_EMAIL ? (Records[i]?.DM_EMAIL).toString() : "",
                                    CUSTODIAN_CODE: Records[i]?.CUSTODIAN_CODE ? (Records[i]?.CUSTODIAN_CODE).toString() : "",
                                    CUSTODIAN_NAME: Records[i]?.CUSTODIAN_NAME ? (Records[i]?.CUSTODIAN_NAME).toString() : "",
                                    CUSTODIAN_MOBILE: Records[i]?.CUSTODIAN_MOBILE ? (Records[i]?.CUSTODIAN_MOBILE).toString() : "",
                                    CUSTODIAN_EMAILID: Records[i]?.CUSTODIAN_EMAILID ? (Records[i]?.CUSTODIAN_EMAILID).toString() : "",
                                    VENUE_CODE: Records[i]?.VENUE_CODE ? (Records[i]?.VENUE_CODE).toString() : "",
                                    VENUE_NAME: Records[i]?.VENUE_NAME ? (Records[i]?.VENUE_NAME).toString() : "",
                                    VENUE_CONTACT_PERSON: Records[i]?.VENUE_CONTACT_PERSON ? (Records[i]?.VENUE_CONTACT_PERSON).toString() : "",
                                    VENUE_MOBILE: Records[i]?.VENUE_MOBILE ? (Records[i]?.VENUE_MOBILE).toString() : "",
                                    VENUE_EMAIL: Records[i]?.VENUE_EMAIL ? (Records[i]?.VENUE_EMAIL).toString() : "",
                                    TRUNK_ID: Records[i]?.TRUNK_ID ? (Records[i]?.TRUNK_ID).toString() : ""
                                    , Error: res.message
                                })
                                errorCounts.push(Count++)

                            }
                            else if (res.status === "SUCCESS") {
                                SucessList.push({
                                    VEHICLEID: Records[i]?.VEHICLEID ? (Records[i].VEHICLEID).toString() : '',
                                    VEHICLENUMBER: Records[i]?.VEHICLENUMBER ? (Records[i]?.VEHICLENUMBER).toString() : "",
                                    DRIVERMOBILE: Records[i]?.DRIVERMOBILE ? (Records[i]?.DRIVERMOBILE).toString() : "",
                                    CSC_REPRESETATIVE: Records[i]?.CSC_REPRESETATIVE ? (Records[i]?.CSC_REPRESETATIVE).toString() : "",
                                    CSC_REPMOBILE: Records[i]?.CSC_REPMOBILE ? (Records[i]?.CSC_REPMOBILE).toString() : "",
                                    DISTRICT_CODE: Records[i]?.DISTRICT_CODE ? (Records[i]?.DISTRICT_CODE).toString() : "",
                                    DISTRICT: Records[i]?.DISTRICT ? (Records[i]?.DISTRICT).toString() : "",
                                    DM_EMAIL: Records[i]?.DM_EMAIL ? (Records[i]?.DM_EMAIL).toString() : "",
                                    CUSTODIAN_CODE: Records[i]?.CUSTODIAN_CODE ? (Records[i]?.CUSTODIAN_CODE).toString() : "",
                                    CUSTODIAN_NAME: Records[i]?.CUSTODIAN_NAME ? (Records[i]?.CUSTODIAN_NAME).toString() : "",
                                    CUSTODIAN_MOBILE: Records[i]?.CUSTODIAN_MOBILE ? (Records[i]?.CUSTODIAN_MOBILE).toString() : "",
                                    CUSTODIAN_EMAILID: Records[i]?.CUSTODIAN_EMAILID ? (Records[i]?.CUSTODIAN_EMAILID).toString() : "",
                                    VENUE_CODE: Records[i]?.VENUE_CODE ? (Records[i]?.VENUE_CODE).toString() : "",
                                    VENUE_NAME: Records[i]?.VENUE_NAME ? (Records[i]?.VENUE_NAME).toString() : "",
                                    VENUE_CONTACT_PERSON: Records[i]?.VENUE_CONTACT_PERSON ? (Records[i]?.VENUE_CONTACT_PERSON).toString() : "",
                                    VENUE_MOBILE: Records[i]?.VENUE_MOBILE ? (Records[i]?.VENUE_MOBILE).toString() : "",
                                    VENUE_EMAIL: Records[i]?.VENUE_EMAIL ? (Records[i]?.VENUE_EMAIL).toString() : "",
                                    TRUNK_ID: Records[i]?.TRUNK_ID ? (Records[i]?.TRUNK_ID).toString() : ""
                                    , Error: res.message
                                })
                                successCounts.push(Count1++)
                            }
                            TotalCounts.push(i)
                        }).catch((err) => {




                        })
                    }
                    setIsLoading(false);
                    setSuccessList(SucessList)
                    setUploadSuccess(true);
                    setSuccessCounts(successCounts)
                    if (TotalCounts == successCounts) {
                        toast.success("Uploaded Successfully")
                    }

                } else {
                    setIsLoading(false)
                    toast.error('Please Select a valid Header format !')

                }
            } else {
                inputRefs.current['txtChooseFile'].focus();
                toast.error('Please Upload File!', {})
                setIsLoading(false)
            }

        }

        setErrorList(errorList)
        setErrorCount(errorCounts)


        //if (errorList.length === 0) {
        //    toast.success("Uploaded Successfully")
        //} if (errorList.length === 1) {
        //    toast.error("Record Already Exist!")
        //} else {
        //    toast.error("Some Records Already Exist!")
        //}
    };



    const showExcelFormat = async () => {
        let data = {
            Token, LoginUserCode
        }
        await fetch('/api/ImportController/ShowImportField', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                setExcelData(res.getImportFields)
            }
            else if (res.status === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
            }

        }).catch((err) => {
            if (err.status === 400) {
                toast.error("Please select valid file!")
            }

        })
    };

    const EXCEL_FILE_URL = `Format.xlsx`;
    const DownloadFileAtURL = (url) => {
        const fileName = url.split('/').pop()

        const aTag = document.createElement('a');
        aTag.href = url
        aTag.setAttribute('download', fileName)
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
    }

    const ERRORDATALIST = () => {
        const workbook = XLSX.utils.book_new();
        let worksheet = XLSX.utils.aoa_to_sheet([
            (Object.keys(errorList[0])),
            ...errorList?.map((records) =>
                [records.VEHICLEID, records.VEHICLENUMBER, records.DRIVERMOBILE, records.CSC_REPRESETATIVE, records.CSC_REPMOBILE, records.DISTRICT_CODE, records.DISTRICT,
                records.DM_EMAIL, records.CUSTODIAN_CODE, records.CUSTODIAN_NAME, records.CUSTODIAN_MOBILE, records.CUSTODIAN_EMAILID, records.VENUE_CODE, records.VENUE_NAME,
                records.VENUE_CONTACT_PERSON, records.VENUE_MOBILE, records.VENUE_EMAIL, records.TRUNK_ID
                    , records.Error
                ]
            )
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Error');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Error.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

    }
    const EventDropdownList = async (EventId) => {


        let data = { Token, LoginUserCode, EventId }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeAutoComplete(res.eventList);
            }).catch((err) => console.log(err));
    };



    useEffect(() => {
        EventDropdownList()
        document.title = "UploadData"
        showExcelFormat()
    }, []);

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Upload Data'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-6 col-md-4 col-sm-6">

                                        <h1 style={{ fontSize: "2em" }}>Note:</h1>

                                        <p>1.Please Upload Only File Of Format XLSX</p>

                                        <p>2.Below Given Fields and Header of XLSX Should Be Same</p>

                                    </div>

                                    <br></br>
                                    <br></br>

                                    {/*  <div className="col-lg-6 col-md-6 col-sm-6">*/}

                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 col-sm-6 mt-3">
                                            <div className="fields">
                                                <label className="form-label">Event  <span className="Required">*</span></label>
                                                <select
                                                    ref={ref => (inputRefs.current['ddlEventCode'] = ref)}
                                                    id="inputState"
                                                    className="form-select"
                                                    value={formData.EventCode}
                                                    onChange={(e) => setFormData({ ...formData, EventCode: e.target.value })}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputRefs.current['txtChooseFile'].focus()
                                                        };
                                                    }}
                                                >
                                                    <option value=''>Select Event </option>
                                                    {
                                                        EventCodeAutoComplete?.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.eventCode}>{item.eventName}</option>
                                                            )
                                                        })
                                                    }
                                                </select>

                                            </div>
                                        </div>


                                        <div className="col-lg-4 col-md-6 col-sm-6 mt-3">
                                            <div className="fields">
                                                <label htmlFor="formFileSm" className="form-label">Choose File<span className="Required">*</span></label>
                                                <input className="form-control form-control-sm"
                                                    onChange={(e) => readFile(e)}
                                                    accept=".xlsx"
                                                    ref={ref => (inputRefs.current['txtChooseFile'] = ref)}
                                                    tabIndex={1} id="formFileSm" type="file" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">

                                        {/*<label htmlFor="exampleFormControlTextarea1" className="form-label">Example textarea</label>*/}
                                        <textarea className="form-control"
                                            defaultValue={ExcelData}
                                            id="exampleFormControlTextarea1" rows="3"></textarea>

                                        <div className="lms-new-button mt-4 ">
                                            <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Upload
                                            </button>
                                            <button className="button export-btn" onClick={() => DownloadFileAtURL(EXCEL_FILE_URL)}>
                                                <i className="bi bi-download" /> Download Format
                                            </button>
                                            {error ?

                                                <button className="button error-btn " onClick={() => {
                                                    ERRORDATALIST()
                                                }}>
                                                    Error list
                                                </button>

                                                : <></>}

                                            <br></br>


                                        </div>
                                        {/*{uploadSuccess && (*/}
                                        {/*    <div className="success-message mt-3" style={{ fontWeight: 'bold', color:"green" }}>File uploaded successfully!</div>*/}
                                        {/*)}*/}
                                        <div className='success,error mt-4 ' style={{ display: "flex", gap: "4px", fontWeight: "bold" }}>
                                            <label className='fs-6 '>{Records?.length ? `Total Records : ${Records?.length}` : ""} </label><br />

                                            <label className='fs-6 text-success'>{success ? ` Success Records : ${success}` : ''} </label><br />
                                            <label className='fs-6 text-danger'>{error ? ` Failed Records : ${error}` : ''} </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <ToastContainer theme='colored' />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            <Footer/>
        </>
    )
}
export default UploadMasterForm;

